package dev.lingvo.site.pages.app.settings.agents

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.tabularNumbers
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.state.WorkspaceActionClaim
import dev.lingvo.site.state.WorkspaceRequestContext
import dev.lingvo.site.state.runWorkspaceAction
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun <T> AgentDetailAction(
    pageClaim: WorkspaceActionClaim,
    label: String,
    variant: LButtonVariant = LButtonVariant.SECONDARY,
    enabled: Boolean,
    busy: Boolean,
    setBusy: (Boolean) -> Unit,
    showLoading: Boolean = false,
    currentContext: () -> WorkspaceRequestContext? = WorkspaceRequestContext::current,
    request: suspend (workspaceSlug: String) -> T,
    launchAction: ((suspend () -> Unit) -> Unit)? = null,
    onSuccess: (T) -> Unit,
    onFailure: (Throwable) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val launch: (suspend () -> Unit) -> Unit = launchAction ?: { action ->
        scope.launch { action() }
    }
    LButton(
        label = label,
        onClick = {
            val claim = pageClaim
                .takeIf { it.remainsAuthorized(currentContext()) }
                ?: return@LButton
            launch {
                runWorkspaceAction(
                    claim = claim,
                    currentContext = currentContext,
                    setBusy = setBusy,
                    transport = request,
                    onSuccess = onSuccess,
                    onFailure = onFailure,
                )
            }
        },
        variant = variant,
        enabled = enabled && !busy,
        loading = showLoading && busy,
    )
}

@Composable
internal fun AgentDetailNumbers(text: String) {
    P(Modifier.tabularNumbers().margin(0.px).toAttrs()) { Text(text) }
}

@Composable
internal fun AgentDetailMuted(text: String) {
    P(
        Modifier
            .color(ColorMode.current.toSitePalette().textSecondary)
            .fontSize(TypeScale.Small)
            .margin(0.px)
            .toAttrs(),
    ) {
        Text(text)
    }
}
